import React, { FC } from 'react';
import { Text, View } from 'react-native';
import TouchableElement from '@components/common/touchableElement';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import { SimpleOnPress } from '@interfaces/base';
import { WithColor } from '@styles/colors';

export type CompareButtonVariant = 'primary' | 'secondary';

interface CompareButtonProps extends Partial<SimpleOnPress>, WithColor {
  disabled?: boolean;
  variant?: CompareButtonVariant;
  textOverride?: string;
  testID?: string;
}

const CompareCancelButton: FC<CompareButtonProps> = ({ C, onPress, disabled = false, variant = 'secondary', textOverride, testID }) => (
  <TouchableElement testID={testID} disabled={disabled} onPress={!disabled ? onPress : undefined}>
    {({ boxStyle, pressHoverColor }) => (
      <View
        style={[
          boxStyle,
          {
            width: '100%',
            height: scale(44),
            borderRadius: scale(10),
            justifyContent: 'center',
            backgroundColor: disabled
              ? C('Button/Light/Disabled')
              : variant === 'primary'
              ? C(pressHoverColor('Button/Light/Primary'))
              : C(pressHoverColor('Button/Light/Secondary')),
          },
        ]}
      >
        <Text
          style={[
            font.Headline,
            {
              color:
                variant === 'primary'
                  ? disabled
                    ? C('Label/Light/Quinary')
                    : C('Label/Light/Selected')
                  : disabled
                  ? C('Label/Light/Quinary')
                  : C('Link/Light/Primary'),
              fontWeight: '500',
              textAlign: 'center',
            },
          ]}
        >
          {textOverride ? textOverride : variant === 'primary' ? i18n.t('Compare') : i18n.t('Cancel')}
        </Text>
      </View>
    )}
  </TouchableElement>
);

export default CompareCancelButton;
